import React, { Component } from "react";
import PropTypes from "prop-types";
import { Chess } from "chess.js"; // import Chess from  "chess.js"(default) if recieving an error about new Chess not being a constructor
import PromotionDialog from "./PromotionDialog";
import { onMove } from "../utils/sound";

const STOCKFISH = window.STOCKFISH;
const game = new Chess()

class Stockfish extends Component {
  static propTypes = { children: PropTypes.func };
  state = { fen: "start", pendingPromotion: null };

  componentDidMount() {
    game.reset();
    this.setState({ fen: game.fen() });
    this.engine = this.engineGame();
    this.engine.prepareMove();
  }

  componentWillUnmount() {
    if (this.gameOverInterval) {
      clearInterval(this.gameOverInterval);
    }
    if (this.workers) {
      this.workers.forEach((w) => w && w.terminate && w.terminate());
    }
  }

  isPromotion = (from, to) => {
    const piece = game.get(from);
    if (!piece || piece.type !== "p") return false;
    const rank = to.charAt(1);
    return (
      (piece.color === "w" && rank === "8") ||
      (piece.color === "b" && rank === "1")
    );
  };

  onDrop = ({ sourceSquare, targetSquare }) => {
    let turn = game.turn() === "w" ? "white" : "black";
    if (turn !== this.props.color) {
      return;
    }
    if (this.isPromotion(sourceSquare, targetSquare)) {
      this.setState({ pendingPromotion: { from: sourceSquare, to: targetSquare } });
      return;
    }
    this.completeMove({ from: sourceSquare, to: targetSquare });
  };

  completeMove = (drop) => {
    const move = game.move(drop);
    if (move === null) {
      return;
    }
    onMove(move, game);
    if (this.checkGameEnd(game)) {
      this.setState({ fen: game.fen() });
      return;
    }
    this.setState({ fen: game.fen() });
    this.engine.prepareMove();
  };

  handlePromotionSelect = (piece) => {
    const drop = { ...this.state.pendingPromotion, promotion: piece };
    this.setState({ pendingPromotion: null });
    this.completeMove(drop);
  };

  checkGameEnd = (g, engine = false) => {
    let setGameResult = this.props.setGameResult;
    let setGameResultDetail = this.props.setGameResultDetail;
    if (!g.isGameOver()) {
        return false;
    } else {
        if (g.isCheckmate() && !engine) {
            setGameResult('win');
            setGameResultDetail('checkmate');
        }
        else if (g.isCheckmate() && engine) {
          setGameResult('lose');
          setGameResultDetail('checkmate');
        }
        else if (g.isThreefoldRepetition()) {
            setGameResult('draw');
            setGameResultDetail('tfr');
        }
        else if (g.isStalemate()) {
            setGameResult('draw');
            setGameResultDetail('stalemate');
        }
        else if (g.isDraw()) {
            setGameResult('draw');
            setGameResultDetail('50 moves rule');
        }
        this.props.setGameState('end')
        this.props.setPgn(game.pgn());
        return true;
    }
  }

  onBlindSubmit = (m) => {
    let move = game.move(m, {sloppy: true});
    if (move === null) { return {'error': `${m} is not a valid move`, 'move': m}}
    else {
      onMove(move, game);
      if (this.checkGameEnd(game)) {
        this.setState({ fen: game.fen() });
        return;
      }
      this.setState({ fen: game.fen() });
      this.engine.prepareMove();
      this.props.setTurn(false);
      return {'error' : '', 'move' : m}
    }
  }

  engineGame = options => {
    options = options || {};
    /// We can load Stockfish via Web Workers or via STOCKFISH() if loaded from a <script> tag.
    let engine =
      typeof STOCKFISH === "function"
        ? STOCKFISH()
        : new Worker(options.stockfishjs || "stockfish.js");
    let evaler =
      typeof STOCKFISH === "function"
        ? STOCKFISH()
        : new Worker(options.stockfishjs || "stockfish.js");
    this.workers = [engine, evaler];
    let engineStatus = {};
    let playerColor = this.props.color;
    let announced_game_over;
    // do not pick up pieces if the game is over
    // only pick up pieces for White

    this.gameOverInterval = setInterval(function() {
      if (announced_game_over) {
        return;
      }

      if (game.isGameOver()) {
        announced_game_over = true;
      }
    }, 500);

    function uciCmd(cmd, which) {
      (which || engine).postMessage(cmd);
    }
    uciCmd("uci");



    function get_moves() {
      let moves = "";
      let history = game.history({ verbose: true });

      for (let i = 0; i < history.length; ++i) {
        let move = history[i];
        moves +=
          " " + move.from + move.to + (move.promotion ? move.promotion : "");
      }

      return moves;
    }

    const prepareMove = () => {
      let turn = game.turn() === "w" ? "white" : "black";
      if (!game.isGameOver()) {
        if (turn !== playerColor) {
          uciCmd("position startpos moves" + get_moves());
          uciCmd("position startpos moves" + get_moves(), evaler);
          uciCmd("eval", evaler);
          uciCmd(`setoption name Skill Level value ${(this.props.botLevel - 1) * 5}`)
          uciCmd("go depth 8");
        }
      }
    };


    evaler.onmessage = function(event) {
      let line;

      if (event && typeof event === "object") {
        line = event.data;
      } else {
        line = event;
      }

      /// Ignore some output.
      if (
        line === "uciok" ||
        line === "readyok" ||
        line.substr(0, 11) === "option name"
      ) {
        return;
      }
    };

    engine.onmessage = event => {
      let line;

      if (event && typeof event === "object") {
        line = event.data;
      } else {
        line = event;
      }
      if (line === "uciok") {
        engineStatus.engineLoaded = true;
      } else if (line === "readyok") {
        engineStatus.engineReady = true;
      } else {
        let match = line.match(/^bestmove ([a-h][1-8])([a-h][1-8])([qrbn])?/);
        /// Did the AI move?
        if (match) {
          const botMove = game.move({ from: match[1], to: match[2], promotion: match[3] });
          onMove(botMove, game);
          this.setState({ fen: game.fen() });
          if (this.checkGameEnd(game, true)) {return;}
          this.props.setTurn(true);
          prepareMove();
          uciCmd("eval", evaler);
          /// Is it sending feedback?
        } else if (
          (match = line.match(/^info .*\bdepth (\d+) .*\bnps (\d+)/))
        ) {
          engineStatus.search = "Depth: " + match[1] + " Nps: " + match[2];
        }

        /// Is it sending feed back with a score?
        if ((match = line.match(/^info .*\bscore (\w+) (-?\d+)/))) {
          let score = parseInt(match[2], 10) * (game.turn() === "w" ? 1 : -1);
          /// Is it measuring in centipawns?
          if (match[1] === "cp") {
            engineStatus.score = (score / 100.0).toFixed(2);
            /// Did it find a mate?
          } else if (match[1] === "mate") {
            engineStatus.score = "Mate in " + Math.abs(score);
          }

          /// Is the score bounded?
          if ((match = line.match(/\b(upper|lower)bound\b/))) {
            engineStatus.score =
              ((match[1] === "upper") === (game.turn() === "w")
                ? "<= "
                : ">= ") + engineStatus.score;
          }
        }
      }
    };

    return {
      start: function() {
        uciCmd("ucinewgame");
        uciCmd("isready");
        engineStatus.engineReady = false;
        engineStatus.search = null;
        prepareMove();
        announced_game_over = false;
      },
      prepareMove: function() {
        prepareMove();
      }
    };
  };

  render() {
    const { fen } = this.state;
    return (
      <>
        {this.props.children({ position: fen, onDrop: this.onDrop, onBlindSubmit: this.onBlindSubmit, game: game })}
        <PromotionDialog open={!!this.state.pendingPromotion} onSelect={this.handlePromotionSelect} />
      </>
    );
  }
}

export default Stockfish;
